__webpack_require__.p = "/dev/923-refactoring-pour-rendre-facile-l-ajout-de-nouveau-type-de-s/";